var _circle, _circle2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDiscordLinear3232 = function SvgIconDiscordLinear3232(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 33,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16.5,
    r: 16,
    fill: "url(#icon-discord-linear32-32_svg__a)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16.5,
    r: 16,
    fill: "url(#icon-discord-linear32-32_svg__b)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.565 12.014c1.807 2.615 2.7 5.564 2.366 8.96a.05.05 0 0 1-.02.037 13.3 13.3 0 0 1-4.002 1.987.05.05 0 0 1-.031 0 .05.05 0 0 1-.026-.019q-.455-.62-.816-1.307a.05.05 0 0 1 .027-.07q.652-.242 1.249-.585a.05.05 0 0 0 .004-.084 6 6 0 0 1-.248-.192.05.05 0 0 0-.053-.006c-2.588 1.176-5.422 1.176-8.04 0a.05.05 0 0 0-.053.007q-.121.098-.247.191a.05.05 0 0 0 .005.084c.398.225.813.423 1.248.585a.05.05 0 0 1 .027.07c-.235.458-.51.894-.817 1.308a.05.05 0 0 1-.056.018 13.4 13.4 0 0 1-3.995-1.988.05.05 0 0 1-.02-.036c-.28-2.938.289-5.912 2.363-8.961a.05.05 0 0 1 .021-.018c1.02-.461 2.114-.8 3.257-.994a.05.05 0 0 1 .052.024c.142.246.303.562.412.82a12.4 12.4 0 0 1 3.658 0c.11-.253.265-.574.406-.82a.05.05 0 0 1 .052-.024c1.143.194 2.237.533 3.256.994a.04.04 0 0 1 .021.019m-6.78 5.585c.012-.869-.631-1.587-1.438-1.587-.801 0-1.438.712-1.438 1.587 0 .874.65 1.586 1.438 1.586.8 0 1.438-.712 1.438-1.586m5.316 0c.012-.869-.63-1.587-1.438-1.587-.8 0-1.438.712-1.438 1.587 0 .874.65 1.586 1.438 1.586.807 0 1.438-.712 1.438-1.586"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-discord-linear32-32_svg__a",
    x1: 0,
    x2: 32,
    y1: 16.5,
    y2: 16.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA613A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#EB476B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#7D3DDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-discord-linear32-32_svg__b",
    x1: 0,
    x2: 32,
    y1: 16.5,
    y2: 16.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA613A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#EB476B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#7D3DDC"
  })))));
};
export default SvgIconDiscordLinear3232;